import { GameState } from '../objects/GameState';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Diagnosis } from '../objects/Diagnosis';
import { Helpers } from '../objects/Helpers';
import initializeInteractiveCursor from 'src/games/shared/InteractiveCursorUtil';
import TranslateApi from 'src/utils/TranslateHelper';

export class SickCellInfoScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    correctDiagnosis: Diagnosis;

    constructor() {
        super({
            key: "SickCellInfoScene_" + Math.random(),
        });
    }

    preload(): void {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("sick_cell_info_scene_map", require("/src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_sick_cell_info_scene.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'sick_cell_info_scene_map' });
        this.correctDiagnosis = GameState.current.correctDiagnosis;
    }

    generateScene() {
        let background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);

        var notesBackground = this.add.image(100, 300, "pixel").setOrigin(0).setDisplaySize(450, 350).setTint(0x000000).setAlpha(0.7);

        this.addObjects();
        Helpers.addNextButton(this);
        Helpers.addBackButton(this);
    }

    addObjects(): void {
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: "#ffffff" };
        var translateString = "Diagnosis.Phaser.SickCellInfoScene.";
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "microscope") {
                var microscope = this.add.image(ob.x, ob.y, "assets", "microscope");
                microscope.setOrigin(0);
                microscope.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = TranslateApi.translate(translateString + "text");
                var box = this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(this.gameWidth/2 - box.displayWidth/2);
                this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "sick_cells") {
                var sickCellColors = Helpers.getRandomUniqueColors(3);
                var sickColor = sickCellColors.findIndex((c) => {
                    return c === this.correctDiagnosis.sickCellColor;
                });
                // If the sick cell color isn't there, add it
                if (sickColor === -1) {
                    sickCellColors.push(this.correctDiagnosis.sickCellColor);
                }

                var indexOfHealthyColor = sickCellColors.findIndex((c) => {
                    return c === this.correctDiagnosis.healthyCellColor;
                });
                // If the healthy color is there, remove it
                if (indexOfHealthyColor !== -1) {
                    sickCellColors.splice(indexOfHealthyColor, 1);
                }

                var group = this.add.group();

                for (var i = 0; i < sickCellColors.length; i++) {
                    var malformed_cell = this.add.image(0, 0, "assets", "temp_sick_cell");
                    malformed_cell.setOrigin(0);
                    malformed_cell.setDisplaySize(80, 80);
                    malformed_cell.setTint(sickCellColors[i]);
                    group.add(malformed_cell);
                }

                Phaser.Actions.GridAlign(group.getChildren(), {
                    x: ob.x,
                    y: ob.y,
                    cellHeight: 100,
                    cellWidth: 100,
                    height: sickCellColors.length / 2,
                    width: 2,
                    position: Phaser.Display.Align.CENTER,
                });
                var labelText1 = TranslateApi.translate(translateString + "abnormalLabel");
                var mc_label = this.add.text(120, ob.y, labelText1, fontStyle);
            }
            else if (ob.name === "normal_cell") {
                var normal_cell = this.add.image(ob.x, ob.y, "assets", "temp_normal_cell");
                normal_cell.setOrigin(0);
                normal_cell.setDepth(1);
                normal_cell.setDisplaySize(ob.width, ob.height);
                normal_cell.setTint(this.correctDiagnosis.healthyCellColor);
                var nc_bounds = normal_cell.getTopRight();
                var labelText2 = TranslateApi.translate(translateString + "normalLabel");
                var nc_label = this.add.text(120, nc_bounds.y + normal_cell.height / 2, labelText2, fontStyle);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/SickCellInfoScene.ts